import { cloudinary } from '@trmediaab/zebra-utils';
import PropTypes from 'prop-types';

const Image = ({
  imageId,
  width,
  aspectRatio,
  variant = 'default',
  className,
}) => {
  const transforms = [];

  if (variant === 'faceSmall') {
    transforms.push('c_thumb', 'g_face');
  }

  return (
    <img
      src={cloudinary.getUrl(imageId, width, aspectRatio, transforms)}
      alt=""
      className={className}
    />
  );
};

Image.propTypes = {
  imageId: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  aspectRatio: PropTypes.arrayOf(PropTypes.number), // length = 2
  variant: PropTypes.oneOf(['default', 'faceSmall']),
  className: PropTypes.string,
};

export default Image;
